/**
 * Data attribute a `pinBelowAnchor` caller's own container (e.g. `DetailAvailabilityCard`'s
 * `<Card>` root, which wraps the title, the grid, AND the legend) sets so the unified select
 * popover can find it via `closest()` from the clicked cell and read its bottom edge — the
 * popover then floats below the WHOLE container instead of just the clicked cell, so it never
 * covers the legend row underneath the grid (CU-86cbh0jhy). Shared so the container and the
 * popover cannot drift apart on the attribute name.
 */
export const PIN_BELOW_CONTAINER_ATTR = 'data-unified-select-pin-container';
